module.exports = __webpack_public_path__ + "static/media/algolia.c2cfae70.svg";